import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ImageDialogTrigger from '../components/ImageDialogTrigger';
import resolvePublicAsset from '../utils/resolvePublicAsset';

function Sobre() {
  const pilares = [
    'Arte, cultura e educação como direitos fundamentais',
    'Valorização de expressões populares, periféricas e comunitárias',
    'Atuação de base comunitária com circulação cultural e formação'
  ];

  const galeria = [
    {
      src: resolvePublicAsset('/images/semanahiphop/2015/emicida_magu.jpg'),
      alt: 'Instituto Acesso Popular em registro institucional',
      className: 'about-gallery-card'
    },
    {
      src: resolvePublicAsset('/images/semanahiphop/2019/thaide_ding.jpg'),
      alt: 'Atividade do Instituto Acesso Popular',
      className: 'about-gallery-card'
    },
    {
      src: resolvePublicAsset('/images/semanahiphop/2017/camarao_magu.jpg'),
      alt: 'Material visual do Instituto Acesso Popular',
      className: 'about-gallery-card'
    }
  ];

  return (
    <div className="about-page">
      <section className="about-hero">
        <Container>
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="about-hero-copy">
                <span className="about-kicker">Quem somos</span>
                <h1>Instituto Acesso Popular</h1>
                <div className="about-pillars">
                  {pilares.map((pilar) => (
                    <span key={pilar}>{pilar}</span>
                  ))}
                </div>
              </div>
            </Col>
            <Col lg={5}>
              <div className="about-hero-visual">
                <div className="about-hero-card about-hero-card-main">
                  <img src={resolvePublicAsset('/images/foto_equipe_acesso_popular.jpg')} alt="Instituto Acesso Popular" className="img-fluid about-hero-main-image"/>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="about-content-section">
        <Container>
          <Row className="g-4 align-items-start">
            <Col lg={8}>
              <div className="about-text-panel">
                <p>O Instituto Acesso Popular de Arte e Cultura é uma organização da sociedade civil sem fins lucrativos que atua na promoção da arte, da cultura e da educação como direitos fundamentais. Com sede em Bauru (SP), o Instituto tem como finalidade a democratização do acesso à cultura, por meio da valorização de expressões artísticas populares, periféricas e comunitárias.</p>
                <p>Ao longo de sua trajetória, o Acesso Popular desenvolveu e apoiou ações culturais, eventos, oficinas formativas e projetos de difusão artística, com atuação destacada nas áreas de cultura urbana, hip-hop, arte de rua, música, poesia e manifestações culturais independentes. Suas iniciativas têm como eixos estruturantes o protagonismo dos artistas locais, a formação de público e o fortalecimento da identidade cultural dos territórios.</p>
                <p>O Instituto compreende a cultura como um instrumento estratégico de transformação social, promoção da cidadania e fortalecimento do pertencimento comunitário. Nesse sentido, prioriza ações com acesso gratuito ou a valores populares, a ocupação qualificada de espaços públicos e o diálogo permanente com comunidades historicamente afastadas dos circuitos culturais tradicionais.</p>
                <p>Reconhecido por sua atuação de base comunitária, o Instituto Acesso Popular integrou a rede de Pontos de Cultura, contribuindo para o fortalecimento de políticas públicas voltadas à cultura de base comunitária e para a ampliação de oportunidades destinadas a jovens, coletivos artísticos e agentes culturais.</p>
                <p>Mais do que realizar eventos, o Instituto Acesso Popular atua na articulação de redes culturais, na troca de saberes e na valorização da diversidade cultural, compreendendo a arte como linguagem, expressão coletiva, resistência simbólica e possibilidade de desenvolvimento social e futuro.</p>
              </div>
            </Col>
            <Col lg={4}>
              <div className="about-side-stack">
                <div className="about-highlight-card">
                  <span className="about-highlight-label">Atuação</span>
                  <ul>
                    <li>Promoção de arte, cultura e educação com acesso ampliado.</li>
                    <li>Fortalecimento de artistas locais, coletivos e agentes culturais.</li>
                    <li>Articulação de redes, formação de público e ocupação de territórios.</li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="about-gallery-section">
        <Container>
          <div className="about-section-heading">
            <span>Presença cultural</span>
            <h4 className="mt-2">Base comunitária, articulação e memória visual</h4>
          </div>
          <Row className="g-4">
            {galeria.map((imagem) => (
              <Col md={4} key={imagem.src}>
                <ImageDialogTrigger
                  src={imagem.src}
                  alt={imagem.alt}
                  triggerClassName={imagem.className}
                  imageClassName="img-fluid"
                />
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default Sobre;